import React, { Component } from 'react';
import { Tabs, Icon } from 'antd';
import SearchProspects from './SearchProspects';
import TrackedProspects from './TrackedProspects';
import '../../combinedStyles';

const TabPane = Tabs.TabPane;

class Prospects extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTab: true,
      trackedTab: false,
      hiddenTab: false,
    };
  }
  tabChange(key) {
    switch (key) {
      case '1':
        this.setState({
          searchTab: true,
          trackedTab: false,
          hiddenTab: false,
        });
        return;
      case '2':
        this.setState({
          searchTab: false,
          trackedTab: true,
          hiddenTab: false,
        });
        return;
      case '3':
        this.setState({
          searchTab: false,
          trackedTab: false,
          hiddenTab: true,
        });
        return;
      default:
        return;
    }
  }

  render() {
    return (
      <div>
        <Tabs defaultActiveKey='1' tabPosition='left' onChange={this.tabChange.bind(this)}>
          <TabPane tab='Search Players' key='1'>
            <SearchProspects active={this.state.searchTab}></SearchProspects>{' '}
          </TabPane>
          <TabPane tab='Your Players' key='2'>
            <TrackedProspects
              type='trackedPlayers'
              active={this.state.trackedTab}
              className='trackedProspects'></TrackedProspects>
          </TabPane>
          {/* <TabPane tab="Hidden Players" key="3"><TrackedProspects type='hiddenPlayers' active={this.state.hiddenTab} className='trackedProspects'></TrackedProspects></TabPane> */}
        </Tabs>
      </div>
    );
  }
}

export default Prospects;



// WEBPACK FOOTER //
// ./src/components/trackedProspects/Prospects.js